

module.exports = {
	api: {
		// server: 'http://localhost:3001',
		// server_base: 'localhost:3001',		
		server: 'https://api2.mymhp.org.uk',
		server_base: 'api2.mymhp.org.uk',
		// server: 'http://chilypep-passport.cloud.distortionhosting.co.uk',
		// server_base: 'chilypep-passport.cloud.distortionhosting.co.uk',
		// server: 'https://api-dev.mymhp.org.uk',
		// server_base: 'api-dev.mymhp.org.uk',
	},

	// domain: 'http://localhost:3000',
	domain: 'https://www.mymhp.org.uk',

	services: {
	},

};



// WEBPACK FOOTER //
// ./src/js/config/index.js